/*
 * @Author: Dong
 * @Date: 2022-05-06 13:26:20
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-03-01 15:44:04
 */
import React, { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { syncBack } from 'root/store/actions';
import Table from 'sup-rc-table';
import messages from '../messages';
import styles from './index.less';
import { formatDate } from 'root/utils/utils';
import { Button, Form, Input, Select, DatePicker } from 'sup-ui';
import { WrappedFormUtils } from 'sup-ui/lib/form/Form';
import moment from 'moment';

interface PropsType {
  form: WrappedFormUtils;
}
let timer: any;
const { Option } = Select;

const LogRecord = (props: PropsType) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { form } = props;
  const { getFieldDecorator } = form;
  const { RangePicker } = DatePicker;

  const { dataSource, pagination } = useSelector((state: reducerStates) => state.syncBack);
  const searchRef = useRef<any>({ current: 1, pageSize: 20 }); // 搜索条件
  const [columns, setColumns] = useState<any>([]);
  const [filteredValue, setFilteredValue] = useState<any>([]);

  const typeList = [
    { label: intl.formatMessage(messages.all), value: '' },
    { label: intl.formatMessage(messages.businessBackup), value: 'BUSI_BACKUP' },
    { label: intl.formatMessage(messages.businessBack), value: 'BUSI_RECOVER' },
    { label: intl.formatMessage(messages.sequenceBackup), value: 'TIME_BACKUP' },
    { label: intl.formatMessage(messages.minioBackup), value: 'MINIO_BACKUP' },
    { label: intl.formatMessage(messages.system), value: 'SYSTEM' },
  ];
  const statusList = [
    { label: intl.formatMessage(messages.all), value: '' },
    { label: intl.formatMessage(messages.success), value: 1 },
    { label: intl.formatMessage(messages.failure), value: 0 },
  ];

  useEffect(() => {
    const newColumns = [
      {
        title: intl.formatMessage(messages.logTime),
        width: 160,
        dataIndex: 'logTime',
        render: (text: string) => {
          return formatDate(text);
        },
      },
      {
        title: intl.formatMessage(messages.operateUser),
        width: 100,
        dataIndex: 'operatorName',
        filterType: 'search',
        filteredValue: filteredValue,
      },
      {
        title: intl.formatMessage(messages.type),
        width: 120,
        dataIndex: 'taskType',
      },
      {
        title: intl.formatMessage(messages.status),
        width: 80,
        dataIndex: 'result',
        render: (text: string) => (
          <span className={text ? styles.successText : styles.failureText}>
            {text ? intl.formatMessage(messages.success) : intl.formatMessage(messages.failure)}
          </span>
        ),
      },
      {
        title: intl.formatMessage(messages.content),
        width: 100,
        dataIndex: 'description',
      },
    ];
    setColumns(newColumns);
  }, [filteredValue]);

  useEffect(() => {
    getData();
    return () => {
      // 组件将要卸载 清除定时器
      clearTimeout(timer);
      timer = null;
    };
  }, []);

  // 轮循获取日志记录数据
  const getData = (params?: any) => {
    dispatch(syncBack.getLogRecord(params));

    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      getData();
    }, 16 * 1000);
  };
  const handleSearch = (searchParams: any, type: string) => {
    const params: any = { ...searchParams.filters, ...searchParams.pagination };
    setFilteredValue(searchParams?.filters?.operatorName);
    // 修改每页数量
    if ((!params.current && searchParams.pageSize !== pagination.pageSize) || type === 'filters') {
      params.current = 1;
    }
    delete params.total;
    searchRef.current = { ...searchRef.current, ...params };
    getData(searchRef.current);
  };

  // 选择日期
  const onChangeDate = (e: any) => {
    const startTime = e[0]?.valueOf();
    const endTime = e[1]?.valueOf();
    searchRef.current = { ...searchRef.current, startTime, endTime };
    getData(searchRef.current);
  };

  // 选择类型和状态
  const onChangeSelect = (e: any, type: string) => {
    if (e !== '') {
      searchRef.current = { ...searchRef.current, [type]: [e] };
    } else {
      searchRef.current = { ...searchRef.current, [type]: [] };
    }
    getData(searchRef.current);
  };

  // 搜素查询
  const onSearch = (e: string) => {
    searchRef.current = { ...searchRef.current, keyword: e };
    getData(searchRef.current);
  };

  // 点击重置
  const clearForm = () => {
    form.resetFields();
    searchRef.current = { current: 1, pageSize: 20 };
    setFilteredValue([]);
    getData(searchRef.current);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{intl.formatMessage(messages.logRecord)}</h2>

      <Form className={styles.form} layout="inline">
        <Form.Item label={intl.formatMessage(messages.recordTime)}>
          {getFieldDecorator('serviceName', {
            initialValue: '',
          })(
            <RangePicker
              onChange={onChangeDate}
              showTime={{
                hideDisabledOptions: false,
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
              }}
            />,
          )}
        </Form.Item>
        <Form.Item label={intl.formatMessage(messages.type)}>
          {getFieldDecorator('type', { initialValue: '' })(
            <Select
              dropdownMatchSelectWidth={true}
              style={{ width: 100 }}
              onChange={(e: any) => {
                onChangeSelect(e, 'taskType');
              }}
            >
              {typeList.map((item: any) => {
                return (
                  <Option value={item.value} key={item.value}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={intl.formatMessage(messages.status)}>
          {getFieldDecorator('status', { initialValue: '' })(
            <Select
              dropdownMatchSelectWidth={true}
              style={{ width: 100 }}
              onChange={(e: any) => {
                onChangeSelect(e, 'result');
              }}
            >
              {statusList.map((item: any) => {
                return (
                  <Option value={item.value} key={item.value}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>,
          )}
        </Form.Item>

        <Form.Item>
          {getFieldDecorator('query', {
            initialValue: '',
          })(
            <Input.Search
              className={styles.queryInput}
              onSearch={onSearch}
              placeholder={intl.formatMessage(messages.searchTip)}
            />,
          )}
        </Form.Item>
        <Form.Item>
          <Button size="small" onClick={clearForm}>
            {intl.formatMessage(messages.reset)}
          </Button>
        </Form.Item>
      </Form>

      <div className={styles.content}>
        <Table
          showSelection={false}
          showSearchIcon={false}
          showColumnsFilter={false}
          columns={columns}
          dataSource={dataSource}
          pagination={pagination}
          onSearch={handleSearch}
          controlColumns
        />
      </div>
    </div>
  );
};

export default Form.create()(LogRecord);
